import React from 'react';
import { useIntl } from 'react-intl';
import { Button, Icon } from 'semantic-ui-react';

const DatasetSubscribeButton = ({ disabled, subscribed }) => {
  const intl = useIntl();
  const buttonText = subscribed ? 'subscriptions.unsubscribe' : 'subscriptions.subscribe';
  const color = subscribed ? 'grey' : null;

  return (
    <Button
      size="tiny"
      compact
      color={color}
      disabled={disabled}
      title={intl.formatMessage({ id: buttonText })}
      className="aridhia-dataset-subscribe-button"
    >
      <Button.Content visible>
        <Icon name="eye" />
      </Button.Content>
    </Button>
  );
};

export default DatasetSubscribeButton;
